// extracted by mini-css-extract-plugin
export default {"rectangle":"slider_rectangle__rQfrw","box":"slider_box__b0MtG","arrow":"slider_arrow__Gv5Tx","values":"slider_values__bqzjU"};